//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loadingIcon from '~/themes/fiskarsMoominDefault/styles/icons/loading-icon.js';

export default {
    name: "SfLoader",
    inject: {
      loadingIcon: {
        default: () => loadingIcon
      }
    },
    props: {
        loading: {
            default: true,
            type: Boolean,
        },
    }
};
